let langData = {
  "ru": {
    "VIEW_ALL": "Смотреть все",
  },
  "ua": {
    "VIEW_ALL": "Дивитись усі",
  }
}

export default langData